module.exports = __webpack_public_path__ + "media/images/payment-2-75a6624be4c410988f07b353c086fef2.svg";